import { render } from "./PricingPage.vue?vue&type=template&id=ee6f9bf0"
import script from "./PricingPage.vue?vue&type=script&lang=js"
export * from "./PricingPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\digitaldistribution.io-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__